export default __webpack_public_path__ + "6f1fc417f495ecfd42e3b6f9269275e6.jpg";